import { createPortal } from "react-dom";

import { Icon } from "@/ds";

import type { ConflictCardProps } from "./types-conflict-card";
import styles from "./conflict-card.module.scss";

export function ConflictCardView({ groups, tratado, card }: ConflictCardProps) {
  if (!card.open) return null;

  return createPortal(
    <div
      ref={card.cardRef}
      id={card.id}
      role="tooltip"
      className={`${styles.card} ${tratado ? styles.cardIgnorado : ""}`}
      style={card.style}
      data-testid="gantt-conflict-tooltip"
    >
      <span className={`${styles.header} ${tratado ? styles.headerIgnorado : ""}`}>
        <Icon name={tratado ? "check" : "exclamation-triangle"} size={10.5} />
        {tratado ? "Conflito ignorado" : "Conflito Detectado"}
      </span>
      {groups.map((group, groupIndex) => (
        <ul key={groupIndex} className={styles.group}>
          {group.lines.map((line) => (
            <li
              key={`${line.tone}-${line.label}`}
              className={`${styles.line} ${line.tone === "start" ? styles.start : styles.end}`}
              data-tone={line.tone}
              data-testid="gantt-conflict-line"
            >
              <strong className={styles.label}>{line.label}</strong>
              <span className={styles.dot} aria-hidden="true">
                ·
              </span>
              <span className={styles.event}>{line.event}</span>
            </li>
          ))}
        </ul>
      ))}
    </div>,
    document.body,
  );
}
